import { BaseModel, BelongsTo } from './base-model'
import { User } from './user'

export interface IPlayCountHeatmap {
  users: { [key: number]: User }
  heatmap: number[][]
}

export class PlayCount extends BaseModel {
  @BelongsTo(User) public user: User
  public count: { [key: number]: number }
}



// WEBPACK FOOTER //
// ./src/models/play-count.ts